import { getApiAxios } from "~/helpers";
import api from "~/config/extensionsApi";

export async function getProductListStockCommand(skus: string) {
  try {
    let response = await getApiAxios(`${api.stock.stock_get_stock_list}?skus=${skus}`);
    if (response.code === 200) {
      return response.result;
    } else {
      return null;
    }
  } catch (error) {
    // toast : Lỗi check tồn sản phẩm
  }
}
